/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {},
    registered () {},
    cached () {},
    updatefound () {},
    updated () {},
    offline () {},
    error (error) {
      console.error('Service worker error:', error)
    }
  })
}

export async function initPushNotifications(userId) {
  console.log('initPushNotifications called, userId:', userId)
  
  if (!userId) return false
  
  // Если уже инициализировано - проверим статус на сервере
  if (window.pushInitialized && window.PushNotification) {
    console.log('Already initialized, returning true')
    return true
  }
  
  try {
    // Если PushNotification уже загружен
    if (window.PushNotification) {
      console.log('PushNotification already loaded, initializing...')
      window.pushInitialized = true
      const result = await window.PushNotification.init(userId)
      console.log('PushNotification init result:', result)
      return result !== false
    }
    
    // Загружаем скрипт
    console.log('Loading push-client.js...')
    await new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = '/push-client.js'
      script.onload = resolve
      script.onerror = reject
      document.head.appendChild(script)
    })
    
    console.log('push-client.js loaded, window.PushNotification:', !!window.PushNotification)
    
    if (window.PushNotification) {
      window.pushInitialized = true
      const result = await window.PushNotification.init(userId)
      console.log('PushNotification init result:', result)
      return result !== false
    }
    
    return false
  } catch (e) {
    console.error('Push init error:', e)
    window.pushInitialized = false
    return false
  }
}
